import Link from 'next/link';

export default function RelatedLinks({ relatedLinks, service }) {
  return (
    <div className="text-black text-center font-light bg-white leading-relaxed pt-20 pb-20 px-20 mx-auto">
      <h3 className="text-2xl mb-4 text-center">More Service Areas</h3>
      <div className="flex flex-wrap justify-center gap-4 text-black">
        {relatedLinks.slice(0, 8).map(({ city, zip }) => (
          <Link
            key={`${city}-${zip}`}
            href={`/${service}/california/${city}/${zip}`}
            prefetch={false}
            className="hover:text-primary transition underline">
            {city.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())}, CA {zip}
          </Link>
        ))}
      </div>
    </div>
  );
}
